import {
  OrderPolicyEntity,
  OrderConsumerEntity,
  OrderGoodsEntity,
  OrderOptionsEntity,
  OrderExtraInfoEntity,
  OrderPriceEntity,
  OrderRelateionEntity,
  OrderProductEntity,
  OrderVoucherEntity,
} from "./Order";

export class FlightPolicyEntity extends OrderPolicyEntity {
  Discount?: number;
  Fare?: number;
  OfficeCode?: string;
  ///<summary>小编码
  ///</summary>
  PnrSmall?: string;
  ///<summary>大编码
  ///</summary>
  PnrBig?: string;
  ///<summary>新小编码
  ///</summary>
  NewPnrSmall?: string;
  ///<summary>新大编码
  ///</summary>
  NewPnrBig?: string;
  /// <summary>
  /// PNR 授权
  /// </summary>
  PnrAuthOffice?: string;
  /// <summary>
  /// 票号授权
  /// </summary>
  TicketAuthOffice?: string;

  ClientThrowDiscount?: number;
  ClientThrowFare?: number;
  SupplyThrowDiscount?: number;
  SupplyThrowFare?: number;
  DirectReduction?: number;
}

export class FlightConsumerEntity extends OrderConsumerEntity {}
export class FlightGoodsEntity extends OrderGoodsEntity {}
export class FlightOptionsEntity extends OrderOptionsEntity {}
export class FlightOrderExtraInfoEntity extends OrderExtraInfoEntity {}
export class FlightPriceEntity extends OrderPriceEntity {}
export class FlightRelateionEntity extends OrderRelateionEntity {}
export class FlightProductEntity extends OrderProductEntity {
  TransferCity?: string;
  ///<summary>经停时间
  ///</summary>
  TransferTime?: string;
  ///<summary>飞机型号
  ///</summary>
  AirplaneModel?: string;
  ShareAirwayCode?: string;
  ShareAirwayName?: string;
  ShareFlightNo?: string;
  ///<summary>退改规则编号
  ///</summary>
  AmendRuleID?: string;
}
export class OrderEntity {
  PageNo?: number;
  Goods?: any[];
  Consumers?: any[];
  Policys?: any[];
  Changes?: any[];
  Vouchers?: any[];
  Products?: any[];
  Prices?: any[];
  Options?: any[];
  ExtraInfos?: any[];

  OrderInvoice?: any;
  InvoiceEntity?: any[];
  IsClient?: boolean;
  IsSupply?: boolean;
  IsOrder?: boolean;
  BusinessTypes?: number[];
  TaskIDs?: string[];
  AddressID?: string;
  InvoiceOrder?: any;
  Price?: number;
  ///<summary>唯一编号
  ///</summary>
  UniqueID?: string;
  ///<summary>订单编号
  ///</summary>
  OrderID?: string;
  ///<summary>原始订单
  ///</summary>
  OriginID?: string;
  ///<summary>原订单号
  ///</summary>
  OriginOrderID?: string;
  ///<summary>公司编号
  ///</summary>
  CompanyID?: string;
  ///<summary>供应名称
  ///</summary>
  CompanyName?: string;
  ///<summary>区域类型
  ///</summary>
  ApplyArea?: number;
  ///<summary>订单类型 销售 改签
  ///</summary>
  OrderType?: number;
  ///<summary>业务单号
  ///</summary>
  BusinessID?: string;
  ///<summary>服务编号
  ///</summary>
  ServiceID?: string;
  ///<summary>产品类型 机票 酒店 旅游
  ///</summary>
  ServiceType?: number;
  ///<summary>业务类型
  ///</summary>
  BusinessType?: number;
  ///<summary>之前状态
  ///</summary>
  BeforeStatus?: number;
  ///<summary>订单状态
  ///</summary>
  OrderStatus?: number;
  ///<summary>状态名称
  ///</summary>
  StatusName?: string;
  ///<summary>产品品牌
  ///</summary>
  ProduceID?: string;
  ///<summary>品牌代码
  ///</summary>
  ProduceCode?: string;
  ///<summary>品牌名称
  ///</summary>
  ProduceName?: string;
  ///<summary>产品编号
  ///</summary>
  ProductID?: string;
  ///<summary>产品代码
  ///</summary>
  ProductCode?: string;
  ///<summary>产品名称
  ///</summary>
  ProductName?: string;
  ///<summary>主图
  ///</summary>
  ProductImage?: string;
  ///<summary>旅客数量
  ///</summary>
  ProductCount?: number;
  ///<summary>产品级别(等级 规格)
  ///</summary>
  LevelID?: string;
  ///<summary>级别代码
  ///</summary>
  LevelCode?: string;
  ///<summary>级别名称 头等舱 商务舱 经济舱 9折经济舱 8折经济舱
  ///</summary>
  LevelName?: string;
  ///<summary>产品批次(团号 航班号 批次号 印刷批次)
  ///</summary>
  BatchID?: string;
  ///<summary>产品批次(团号 航班号 批次号 印刷批次)
  ///</summary>
  BatchCode?: string;
  ///<summary>下单方式(线上或门店)
  ///</summary>
  CreateMode?: number;
  ///<summary>消费日期
  ///</summary>
  ConsumerDate?: Date;
  ConsumerDateEnd?: Date;
  ///<summary>消费者名称
  ///</summary>
  ConsumerName?: string;
  ///<summary>消费目的
  ///</summary>
  ConsumerIntent?: string;
  ///<summary>搜索索引
  ///</summary>
  KeyWords?: string;
  ///<summary>联系人编号
  ///</summary>
  ContactID?: string;
  ///<summary>联系人姓名
  ///</summary>
  ContactName?: string;
  ///<summary>联系人电话
  ///</summary>
  ContactPhone?: string;
  ///<summary>联系人邮箱
  ///</summary>
  ContactEmail?: string;
  ///<summary>供应编号
  ///</summary>
  SupplyID?: string;
  ///<summary>供应名称
  ///</summary>
  SupplyName?: string;
  ///<summary>客户级别
  ///</summary>
  SupplyLevel?: string;
  ///<summary>供应订单号
  ///</summary>
  SupplyUniqueID?: string;
  ///<summary>供应联系人编号
  ///</summary>
  SupplyContactID?: string;
  ///<summary>供应联系人名称
  ///</summary>
  SupplyContactName?: string;
  ///<summary>供应联系人电话
  ///</summary>
  SupplyContactPhone?: string;
  ///<summary>供应联系人邮箱
  ///</summary>
  SupplyContactEmail?: string;
  SupplyOrderStatus?: number;
  ///<summary>供应订单状态名称
  ///</summary>
  SupplyStatusName?: string;
  ///<summary>收款总金额
  ///</summary>
  PaymentAmount?: number;
  ///<summary>收款状态
  ///</summary>
  PaymentStatus?: number;
  ///<summary>付款状态名称
  ///</summary>
  PaymentStatusName?: string;
  ///<summary>收款时间
  ///</summary>
  PaymentTime?: Date;
  ///<summary>付款方式
  ///</summary>
  PaymentMode?: number;
  ///<summary>最后付款时间
  ///</summary>
  LastPaymentTime?: Date;
  LastPaymentTimeEnd?: Date;
  ///<summary>客户编号
  ///</summary>
  ClientID?: string;
  ///<summary>客户名称
  ///</summary>
  ClientName?: string;
  ///<summary>客户级别
  ///</summary>
  ClientLevel?: string;
  ///<summary>客户联系人编号
  ///</summary>
  ClientContactID?: string;
  ///<summary>客户联系人名称
  ///</summary>
  ClientContactName?: string;
  ///<summary>客户联系人电话
  ///</summary>
  ClientContactPhone?: string;
  ///<summary>客户联系人邮箱
  ///</summary>
  ClientContactEmail?: string;
  ///<summary>客户订单编号
  ///</summary>
  ClientUniqueID?: string;
  ///<summary>订单状态
  ///</summary>
  ClientOrderStatus?: number;
  ///<summary>客户订单状态名称
  ///</summary>
  ClientStatusName?: string;
  ///<summary>收款总金额
  ///</summary>
  ReceiveAmount?: number;
  ///<summary>收款状态
  ///</summary>
  ReceiveStatus?: number;
  ///<summary>收款状态名称
  ///</summary>
  ReceiveStatusName?: string;
  ///<summary>收款时间
  ///</summary>
  ReceiveTime?: Date;
  ReceiveTimeEnd?: Date;
  ///<summary>收款方式
  ///</summary>
  ReceiveMode?: number;
  ///<summary>出票时间
  ///</summary>
  DoneUserID?: string;
  ///<summary>出票时间
  ///</summary>
  DoneUserName?: string;
  ///<summary>出票时间
  ///</summary>
  DoneTime?: Date;
  DoneTimeEnd?: Date;
  ///<summary>锁定人编号
  ///</summary>
  LockUserID?: string;
  ///<summary>锁定人名称
  ///</summary>
  LockUserName?: string;
  ///<summary>锁定时间
  ///</summary>
  LockTime?: Date;
  LockTimeEnd?: Date;
  ///<summary>超时时间
  ///</summary>
  OverTime?: Date;
  OverTimeEnd?: Date;
  ///<summary>特性代码
  ///</summary>
  FeatureCodes?: string;
  ///<summary>交易角色
  ///</summary>
  TradeRole?: string;
  ///<summary>数据级别代码
  ///</summary>
  DataLevelCode?: string;
  ///<summary>备注
  ///</summary>
  Remark?: string;
  ///<summary>创建时间
  ///</summary>
  CreateTime?: Date;
  CreateTimeEnd?: Date;
  ///<summary>创建人编号
  ///</summary>
  CreateUserID?: string;
  ///<summary>创建人编号
  ///</summary>
  CreateUserName?: string;
  ///<summary>修改时间
  ///</summary>
  UpdateTime?: Date;
  UpdateTimeEnd?: Date;
  ///<summary>修改人编号
  ///</summary>
  UpdateUserID?: string;
  ///<summary>修改人编号
  ///</summary>
  UpdateUserName?: string;
  SupplyOriginID?: string;
  ClientOriginID?: string;
  ReasonType?: string;
  Reason?: string;
  ReasonDetail?: string;
  ///<summary>收款总额（包含附加产品）
  ///</summary>
  ReceiveTradeAmount?: number;
  ///<summary>付款总额（包含附加产品）
  ///</summary>
  PaymentTradeAmount?: number;

  ///<summary>消费地址
  ///</summary>
  ConsumerCityCode?: string;
  ///<summary>消费地址
  ///</summary>
  ConsumerCityName?: string;
  ///<summary>消费地址
  ///</summary>
  ConsumerZoneCode?: string;
  ///<summary>消费地址
  ///</summary>
  ConsumerZoneName?: string;
  ///<summary>消费地址
  ///</summary>
  ConsumerAddress?: string;
  ///<summary>消费地址
  ///</summary>
  FinishedCityCode?: string;
  ///<summary>消费地址
  ///</summary>
  FinishedCityName?: string;
  ///<summary>消费地址
  ///</summary>
  FinishedZoneCode?: string;
  ///<summary>消费地址
  ///</summary>
  FinishedZoneName?: string;
  ///<summary>消费日期
  ///</summary>
  FinishedDate?: string;
  ///<summary>消费地址
  ///</summary>
  FinishedAddress?: string;
  ///<summary>消费时间(飞行时间)
  ///</summary>
  ConsumerDuration?: string;

  UnionID?: string;
  ConsumerDates?: string;
  ProfitLoss?: number;
  BookingUserID?: string;
  BookingUserName?: string;
  ProfitLossReason?: string;
  ///<summary>偏好
  ///</summary>
  Preference?: string;

  /// <summary>
  /// 保留时间
  /// </summary>
  RetentionTime?: Date;

  RetentionTimeEnd?: Date;
}
export class FlightOrderEntity extends OrderEntity {
  productList?: FlightProductEntity[];
  voyageList?: any[];
  originalFlight?: any[];
  ticketList?: FlightVoucherEntity[];
  policy?: FlightPolicyEntity;
  passList?: any[];
  isChange?: boolean;
  isCheck?: boolean;
  next?: boolean;

  PnrSmall?: string;
  VoucherNo?: string;
  UniqueIds?: string[];
  ///<summary>经停城市
  ///</summary>
  TransferCity?: string;
  ///<summary>经停时间
  ///</summary>
  TransferTime?: string;
  ShareAirwayCode?: string;
  ShareAirwayName?: string;
  ShareFlightNo?: string;
  ///<summary>飞机型号
  ///</summary>
  AirplaneModel?: string;
  ///<summary>退改规则编号
  ///</summary>
  AmendRuleID?: string;
}
export class FlightVoucherEntity extends OrderVoucherEntity {
  FlightConsumer?: any;
}
export class IssueTicketModel {
  Order?: any;
  Tickets?: FlightVoucherEntity[];
}
export class DealTicketModel {
  id?: string;
  TicketNo?: string;
  TicketPrice?: number;
  TicketFare?: number;
  OtherTaxFare?: number;
  BrokerageFare?: number;
}
export class OverseasTicketModel {
  OrderID?: string;
  TicketIDs?: string[];
  TicketList?: FlightVoucherEntity[];
  VoyageIDs?: any[];
  FlightGoodsEntity?: any[];
  Order?: any;
}
